exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-placeholder{color:red;font-size:.9em}.errors{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4b870f90!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/NumberInput.vue
// module id = 883
// module chunks = 2